<template>
  <div>
    <div v-if="plans.init === 1">
      <v-layout row wrap class="mb-4">
        <v-btn round color="primary" @click.prevent="doBack">
          <v-icon left dark>mdi-chevron-left</v-icon>
          Back
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn flat color="primary" v-if="showReview" @click.prevent="promptReselect = true">
          Re-select Plan
          <v-icon right>mdi-pencil</v-icon>
        </v-btn>
      </v-layout>
      <transition name="slide-x-transition" mode="out-in">
        <review-plan v-if="showReview" :plan="$store.getters.maidQuoteSelectedPlan" :limitsText="compileLimitsText" :reviewPlanParam="$store.state.agency.quotation.maidParam.reviewPlan" recalcMethodName="maidQuoteRecalculate" @proceed="doProceedReview"></review-plan>
        <common-plans v-else :plans="plans.plans" :limitsText="compileLimitsText" :selected="maidForm.planNo" :currPrefix="currPrefix" iconType="MAID" @selectPlan="doSelectPlan"></common-plans>
      </transition>
      <confirm v-model="promptReselect" @ok="doReselectPlan">
        Are you sure you want to re-select plan? Any plan adjustment will be discarded.
      </confirm>
      <v-layout row wrap class="mt-3">
        <v-btn round color="primary" @click.prevent="doBack">
          <v-icon left dark>mdi-chevron-left</v-icon>
          Back
        </v-btn>
      </v-layout>
    </div>
    <div v-else>
      <v-layout row wrap class="mb-4">
        <v-btn round color="primary" @click.prevent="doBack">
          <v-icon left dark>mdi-chevron-left</v-icon>
          Back
        </v-btn>
      </v-layout>
      <loader :height="425" :init="doInit" :errorMsgs="plans.initErr" loadText="Loading Plans..." errorText="Failed to load Plans" :loading="plans.init === 0"></loader>
      <v-layout row wrap class="mt-3">
        <v-btn round color="primary" @click.prevent="doBack">
          <v-icon left dark>mdi-chevron-left</v-icon>
          Back
        </v-btn>
      </v-layout>
    </div>
  </div>
</template>

<script>
import clone from 'clone'
import { AGENCY_QUOTATION_LIFECYCLE, QUOTE_MAID_PLANS, QUOTE_MAID_ADJ_CANCEL } from '@/store/types'
import MessageMixin from '@/mixins/message'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import CommonPlans from '../../shared/plans/CommonPlans'
import ReviewPlan from '../../shared/plans/ReviewPlan'

export default {
  data() {
    return {
      maidForm: {
        planNo: undefined
      },
      showReview: false,
      promptReselect: false
    }
  },
  computed: {
    plans() {
      return this.$store.state.agency.quotation.maidParam.plans
    },
    compileLimitsText() {
      // Need give the main row a main attribute (appearance tweak)
      const result = clone(this.plans.limitsText)
      for (const limit of result) {
        if (limit.value.indexOf('.') === -1) {
          limit.main = true
        }
      }
      return result
    },
    currPrefix() {
      return this.$store.state.agency.quotation.commonInfo.currPrefix
    },
    globalMaidForm() {
      return this.$store.state.agency.quotation.maidForm
    }
  },
  methods: {
    doInit() {
      if (this.plans.init !== 1) {
        this.$store.dispatch('maidQuotePlans')
      }
      this.maidForm.planNo = this.globalMaidForm.planNo

      if (this.maidForm.planNo) {
        this.showReview = true
      }
    },
    doBack() {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 1)
      this.$router.push({ name: 'maidQuote' })
    },
    doSelectPlan(obj) {
      if (obj) {
        this.maidForm.planNo = obj.value
        if (obj.proceed) {
          this.doProceed()
        }
      }
    },
    doReselectPlan() {
      this.showReview = false
      this.promptReselect = false
      this.$store.commit(QUOTE_MAID_ADJ_CANCEL)
      this.maidForm.planNo = null
    },
    doProceed() {
      if (this.maidForm.planNo) {
        this.$store.commit(QUOTE_MAID_PLANS, this.maidForm.planNo)
        this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 3)
        this.$router.push({ name: 'maidQuoteRisk' })
      } else {
        this.$snotify.error('Please select a Plan')
      }
    },
    doProceedReview() {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 3)
      this.$router.push({ name: 'maidQuoteRisk' })
    },
    async doPartialSave() {
      // No mandatory validation here. Commit whatever thats on screen and do neccesary actions before saving
      // Must return true/false
      try {
        // No need commit planNo for save
        // this.$store.commit(QUOTE_MAID_PLANS, this.maidForm.planNo)
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 2) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 2)
    }
    this.doInit()
  },
  components: {
    CommonPlans,
    ReviewPlan
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin
  ]
}
</script>

<style>
</style>
